import { useId } from 'react';
import { FieldValues, SubmitHandler, useForm } from 'react-hook-form';
import type { ZodType, ZodTypeDef } from 'zod';
import { zodResolver } from '@hookform/resolvers/zod';
import type { FormProps } from './types';

function Form<
  TFieldValues extends FieldValues = FieldValues,
  Schema extends ZodType<TFieldValues, ZodTypeDef, TFieldValues> = ZodType<TFieldValues, ZodTypeDef, TFieldValues>,
>({ onSubmit, defaultValues, children, options, schema }: FormProps<TFieldValues, Schema>) {
  const formId = `form${useId()}`;
  const methods = useForm<TFieldValues>({
    mode: 'all',
    defaultValues,
    resolver: schema && zodResolver(schema),
    shouldUnregister: true,
    ...options,
  });

  const formSubmit: SubmitHandler<TFieldValues> = args => {
    onSubmit(args, methods);
  };

  return (
    <form onSubmit={methods.handleSubmit(formSubmit)} id={formId} name={formId}>
      {children(methods)}
    </form>
  );
}

export default Form;
